<div class="business-navbar__snackbar-container" [ngClass]="{'business-navbar__snackbar-container--visible': visible$ | async}">
    <div class="business-navbar__snackbar-container__simple-snackbar">
        <span class="business-navbar__snackbar-container__simple-snackbar__text">
            {{ text$ | async }}
        </span>
        <div class="business-navbar__snackbar-container__simple-snackbar__actions">
            <atlas-button [text]="actionText$ | async" (onClick)="closeSnackbar()"></atlas-button>
        </div>
    </div>
</div>
